export default "__VITE_ASSET__f8a09fbc__"